import React, { FC } from 'react'

import { TSignalFeedback } from '../types/SignalFeedback.types'
import { SignalFeedbackView } from './SignalFeedbackView'
import { useSignalFeedback } from '../hooks/useSignalFeedback'

export const SignalFeedback: FC<TSignalFeedback> = ({
  icon,
  title,
  details,
  type,
  strongDetails = '',
}) => {
  const { InterIcon, intensity } = useSignalFeedback({ icon, type, details, title })
  return (
    <SignalFeedbackView
      icon={InterIcon}
      title={title}
      details={details}
      intensity={intensity}
      type={type}
      strongDetails={strongDetails}
    />
  )
}
